import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import { ActionablesContext } from '@contexts/ActionablesContext'
import { Card, CardContent, CardFooter } from '@components/layout/Card'
import { TabHeader } from '@components/TabHeader'

import { DetailedRisk } from './DetailedRisk'
import { SimpleRisk } from './SimpleRisk'
import { ImplementedPlanRisk } from './ImplementedPlanRisk'
import { ExternalRiskProfile } from './ExternalRiskProfile'

export const Risk = (props) => {
  const { riskReadOnly } = useContext(ActionablesContext)
  const { useExternalRiskProfiling } = props
  const [selectedTab, setSelectedTab] = useState(props.riskProfile.selected === 'simple' ? 1 : 0)
  const [takingQuestionnaire, setTakingQuestionnaire] = useState(false)

  const saygScenariosEnabled = !!props.crudActions

  const shouldShowFooter = () =>
    selectedTab === 0 && props.riskProfile.selected === 'detailed'

  if (useExternalRiskProfiling) {
    return <ExternalRiskProfile { ...props } saygScenariosEnabled={saygScenariosEnabled} />
  }
  if (riskReadOnly) {
    return <ImplementedPlanRisk { ...props } saygScenariosEnabled={saygScenariosEnabled} />
  }
  return (
    <Card className='scenario-risk'>
      <TabHeader
        title={`Let's analyze your risk`}
        subheader={
          <span>Your <b>{props.riskProfile.selected === 'simple' ? 'Simple risk' : 'Detailed risk' }</b> is currently being used.</span>
        }
      >
        <TabHeader.Filter filter={props.filter} />
      </TabHeader>
      <CardContent>
        <RiskTabs
          {...props}
          saygScenariosEnabled={saygScenariosEnabled}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          takingQuestionnaire={takingQuestionnaire}
          setTakingQuestionnaire={setTakingQuestionnaire}
        />
      </CardContent>
      { shouldShowFooter() &&
      <CardFooter>
        <a
          className='text-link asset-action'
          data-tracking='true' data-event-name='Scenario planning -> Retake risk questions'
          onClick={() => setTakingQuestionnaire(true)}>Retake risk questions</a>
      </CardFooter>
      }
    </Card>
  )
}

const RiskTabs = (props) =>
  <Tabs
    defaultIndex={props.riskProfile.selected === 'simple' ? 1 : 0}
    className='app-tabs'
    onSelect={index => {
      props.setSelectedTab(index)
      props.setTakingQuestionnaire(false)
    }}
  >
    <TabList className='app-tabs__list flex justify-end'>
      <Tab
        className='app-tabs__list-item'
        selectedClassName='app-tabs__list-item--selected'>Detailed Risk</Tab>
      <Tab
        className='app-tabs__list-item'
        selectedClassName='app-tabs__list-item--selected'>Simple Risk</Tab>
    </TabList>
    <TabPanel>
      <DetailedRisk {...props} />
    </TabPanel>
    <TabPanel>
      <SimpleRisk {...props} />
    </TabPanel>
  </Tabs>

Risk.propTypes = {
  riskProfile: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired,
  isRetired: PropTypes.bool.isRequired,
  clientPronoun: PropTypes.string.isRequired,
  yearsToRetirement: PropTypes.number.isRequired,
  updateRiskHandler: PropTypes.func,
  inflation: PropTypes.number.isRequired,
  // XXX: Make sure these are available from the implementedPlan
  isWealthManager: PropTypes.bool.isRequired,
  useExternalRiskProfiling: PropTypes.bool,

  crudActions: PropTypes.object.isRequired,
  onCreateNewScenario: PropTypes.func,
  filter: PropTypes.func
}
